import { Controller } from 'stimulus';

class StickyOrderFormController extends Controller {
  connect() {
    this.trigger = document.querySelector('.js-sticky-order-form-trigger');
  }

  onWindowScroll() {
    const isVisible = this.checkTriggerVisibility();

    this.element.classList.toggle('is-visible', !isVisible);
  }

  checkTriggerVisibility() {
    const triggerRect = this.trigger.getBoundingClientRect();
    const triggerTop = triggerRect.top;

    return triggerTop >= 0;
  }
}

StickyOrderFormController.targets = [];

export default StickyOrderFormController;
